"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddressUtil = void 0;
const bech32_1 = require("bech32");
class AddressUtil {
    validateHashString(puzzleHash) {
        let ph = puzzleHash;
        if (ph.startsWith("0x"))
            ph = ph.slice(2, ph.length);
        if (ph.length !== 64 || !(new RegExp(/^[0-9A-Fa-f]+$/)).test(ph))
            return "";
        return ph;
    }
    puzzleHashToAddress(puzzleHash, prefix = "xch") {
        const puzzHash = Buffer.from(this.validateHashString(puzzleHash), "hex");
        if (puzzHash.length !== 32)
            return "";
        return bech32_1.bech32m.encode(prefix, bech32_1.bech32m.toWords(puzzHash));
    }
    addressToPuzzleHash(address, maxLen) {
        try {
            return Buffer.from(bech32_1.bech32m.fromWords(bech32_1.bech32m.decode(address, maxLen).words)).toString("hex");
        }
        catch (_) {
            return "";
        }
    }
}
exports.AddressUtil = AddressUtil;
//# sourceMappingURL=address.js.map